import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { auth, sendPasswordResetEmail } from "../firebase";
import Logo from "../assets/logo.png";

function Reset() {
  const [email, setEmail] = useState("");
  const [user, loading] = useAuthState(auth);
  const history = useHistory();

  useEffect(() => {
    if (loading) return;
    if (user) history.replace("/tables");
  }, [user, loading]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex' }}>

      {/* ── Left panel (branding) ── desktop only */}
      <div className="d-none d-lg-flex" style={{
        flex: '0 0 45%',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '3rem',
        background: 'linear-gradient(145deg, var(--sb-bg-elevated) 0%, var(--sb-bg-surface) 100%)',
        borderRight: '1px solid var(--sb-border)',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', top: '-80px', left: '-80px',
          width: 320, height: 320,
          background: 'radial-gradient(circle, rgba(59,130,246,0.12) 0%, transparent 70%)',
          pointerEvents: 'none',
        }} />

        <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none' }}>
          <img src={Logo} width={32} height={30} alt="StakeBits" />
          <span style={{ fontWeight: 700, fontSize: '1.1rem', color: 'var(--sb-text-primary)' }}>StakeBits</span>
        </Link>

        <div>
          <h2 style={{ color: 'var(--sb-text-primary)', fontWeight: 800, fontSize: '2rem', letterSpacing: '-0.03em', marginBottom: '1rem', lineHeight: 1.2 }}>
            Locked out?<br />We've got you.
          </h2>
          <p style={{ color: 'var(--sb-text-secondary)', fontSize: '0.95rem', lineHeight: 1.7, maxWidth: 320 }}>
            Enter your email and we'll send you a link to reset your password and get back to your account.
          </p>
        </div>

        <p style={{ color: 'var(--sb-text-muted)', fontSize: '0.78rem' }}>© 2024 StakeBits</p>
      </div>

      {/* ── Right panel (form) ── */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '3rem 2rem',
        background: 'var(--sb-bg-base)',
      }}>
        <div style={{ width: '100%', maxWidth: 400 }}>
          <h2 style={{ color: 'var(--sb-text-primary)', fontWeight: 700, fontSize: '1.6rem', letterSpacing: '-0.02em', marginBottom: '0.4rem' }}>
            Reset your password
          </h2>
          <p style={{ color: 'var(--sb-text-secondary)', fontSize: '0.9rem', marginBottom: '2rem' }}>
            We'll send a reset link to your email address.
          </p>

          <form onSubmit={e => { e.preventDefault(); sendPasswordResetEmail(email.toLowerCase()); }}>
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', color: 'var(--sb-text-muted)', fontSize: '0.73rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '0.4rem' }}>
                Email
              </label>
              <input
                type="email"
                className="form-control"
                placeholder="you@example.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn btn-primary w-100" style={{ fontWeight: 600, padding: '0.7rem' }}>
              Send reset email
            </button>
          </form>

          <p style={{ textAlign: 'center', marginTop: '2rem', fontSize: '0.875rem', color: 'var(--sb-text-muted)' }}>
            Remember your password?{' '}
            <Link to="/login" style={{ color: 'var(--sb-accent)', fontWeight: 500 }}>Log in</Link>
            {'  ·  '}
            <Link to="/register" style={{ color: 'var(--sb-accent)', fontWeight: 500 }}>Create account</Link>
          </p>
        </div>
      </div>

    </div>
  );
}

export default Reset;
